// extracted by mini-css-extract-plugin
export default {"buyMoreContainer":"styles_buyMoreContainer__3s9bd","fullView":"styles_fullView__pLKnR","shimmer":"styles_shimmer__3tyL8"};